export default [
  {
    images: ['/img/1.jpg', '/img/2.jpg', '/img/3.jpg', '/img/4.jpg'],
    heading: 'Fishing in the sand',
    text: 'Dinosaurs are extinct today because they lacked opposable thumbs and the brainpower to build a space program.'
  },
  {
    images: ['/img/2.jpg', '/img/3.jpg', '/img/4.jpg', '/img/1.jpg'],
    heading: 'Fishing in the sand',
    text: 'Dinosaurs are extinct today because they lacked opposable thumbs and the brainpower to build a space program.'
  },
  {
    images: ['/img/3.jpg', '/img/4.jpg', '/img/1.jpg', '/img/2.jpg'],
    heading: 'Fishing in the sand',
    text: 'Dinosaurs are extinct today because they lacked opposable thumbs and the brainpower to build a space program.'
  },
  {
    images: ['/img/4.jpg', '/img/1.jpg', '/img/2.jpg', '/img/3.jpg'],
    heading: 'Fishing in the sand',
    text: 'Dinosaurs are extinct today because they lacked opposable thumbs and the brainpower to build a space program.'
  }
]



// WEBPACK FOOTER //
// src/components/ActivityList/SampleActivitiesData.js